// import React, { useState, useEffect } from 'react';
// import { Link, useSearchParams } from 'react-router-dom';
// import apiService from '../services/apiService';
import './SetupAgentPage.css';
import './ViewAgentPage.css';
import './AttributeRegistryPage.css';
// import { 
//   getAvailableEnvironments, 
//   getSelectedEnvironment, 
//   saveSelectedEnvironment,
//   getApiEndpoints,
//   ENVIRONMENT_LABELS,
//   getEnvironmentColor
// } from '../utils/apiConfig';


const CompareArchivesPage = () => {
//   const [searchParams] = useSearchParams();
//   const [instances, setInstances] = useState([]);
//   const [loadingInstances, setLoadingInstances] = useState(false);
//   const [compareArchiveForm, setCompareArchiveForm] = useState({
//     instanceId: searchParams.get('instanceId') || ''
//   });
//   // const [loading, setLoading] = useState(false);
//   // const [result, setResult] = useState(null);
//   // const [error, setError] = useState(null);
//   // const [selectedInstance, setSelectedInstance] = useState('');

//   // Environment selection
//   const [selectedEnvironment, setSelectedEnvironment] = useState(getSelectedEnvironment());
//   const availableEnvironments = getAvailableEnvironments();
    
//   // Get API endpoints based on selected environment
//   const apiEndpoints = getApiEndpoints(selectedEnvironment);
//   const INSTANCE_DROPDOWN_API = apiEndpoints.instanceDropdown;

//   // const getUserRole = () => (
//   //   JSON.parse(localStorage.getItem('user') || 'null')?.role || ''
//   // ); 

//     // Handle environment change
//   const handleEnvironmentChange = (e) => {
//     const newEnvironment = e.target.value;
//     setSelectedEnvironment(newEnvironment);
//     saveSelectedEnvironment(newEnvironment);
//     setResult(null);
//     setError(null);
//   };

//   const handleInstanceChange = (e) => {
//     const instanceId = e.target.value;
//     setError(null);
//     setResult(null);

//     setCompareArchiveForm(prevForm => ({
//       ...prevForm,
//       instanceId
//     }));
//     setSelectedInstance(instanceId); 
//   };    

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setError(null);
//     setResult(null);
//   };

//   // Fetch Connect instances on component mount and when environment changes
//   useEffect(() => {
//     const fetchInstances = async () => {
//       setLoadingInstances(true);
//       try {
//         const response = await apiService.get(INSTANCE_DROPDOWN_API);
//         if (response.data.status === 'ok') {
//           setInstances(response.data.instances || []);
//         } else {
//           console.error('Failed to load instances:', response.data.message);
//         }
//       } catch (err) {
//         console.error('Error fetching instances:', err);
//       } finally {
//         setLoadingInstances(false);
//       }
//     };
//     fetchInstances();
//   }, [INSTANCE_DROPDOWN_API, selectedEnvironment]);

     return null;

//   return (
//        <div className="setup-page">
//          <div className="page-header">
//            <div>
//                <h1>Compare Connect Archives</h1>
//                  <p className="page-subtitle">Compare Connect archives</p>
//            </div>
//            <Link to="/archive-management" className="btn btn-secondary">
//             ← Back to Manage Archives
//           </Link>
//          </div>
   
//          {/* Environment Selector */}
//          <div className="environment-selector" style={{
//            backgroundColor: '#f9f9f9',
//            border: '2px solid #e0e0e0',
//            borderRadius: '8px',
//            padding: '16px',
//            marginBottom: '20px',
//            display: 'flex',
//            alignItems: 'center',
//            gap: '12px'
//          }}>
//            <label htmlFor="environment" style={{ 
//              fontWeight: 'bold', 
//              fontSize: '16px',
//              minWidth: '120px'
//            }}>
//              Environment:
//            </label>
//            <select
//              id="environment"
//              value={selectedEnvironment}
//              onChange={handleEnvironmentChange}
//              style={{
//                padding: '10px 16px',
//                fontSize: '15px',
//                borderRadius: '6px',
//                border: '2px solid #ccc',
//                backgroundColor: 'white',
//                cursor: 'pointer',
//                fontWeight: '500',
//                minWidth: '200px'
//              }}
//            >
//              {availableEnvironments.map(env => (
//                <option key={env} value={env}>
//                  {ENVIRONMENT_LABELS[env]} ({env})
//                </option>
//              ))}
//            </select>
//            <span style={{
//              padding: '6px 12px',
//              borderRadius: '4px',
//              fontSize: '13px',
//              fontWeight: 'bold',
//              color: 'white',
//              backgroundColor: getEnvironmentColor(selectedEnvironment)
//            }}>
//              {selectedEnvironment}
//            </span>
//          </div>

//         <div className="form-container">
//         <form onSubmit={handleSubmit} className="setup-form">
//           <div className="form-section">
//             <h3>Compare Connect Archives</h3>

//             <div className="form-group">
//                 <label htmlFor="instanceId">Instance *</label>
//                 <select
//                   id="instanceId"
//                   value={compareArchiveForm.instanceId}
//                   onChange={handleInstanceChange}
//                   required
//                   disabled={loadingInstances}
//                 >
//                   <option value="">
//                     {loadingInstances ? 'Loading instances...' : 'Select an instance...'}
//                   </option>
//                   {instances.map((instance) => (
//                     <option key={instance.id} value={instance.id}>
//                       {instance.name} ({instance.status})
//                     </option>
//                   ))}
//                 </select>
//                 <small>Select an Amazon Connect instance</small>
//             </div>         
//           </div>
//         </form>
//       </div>
//     </div>
//   );
};

export default CompareArchivesPage;